// Specchio lato client di backend/app/commissioni/resolver.py.
// Per ogni pratica il calcolo scorre le righe dall'alto e usa la prima che
// corrisponde: 1 = la prima guardata, 6 = l'ultima.

export interface PrecedenzaItem {
  tier: number;
  titolo: string; // "vale per", per la scala e la colonna Riga
  descrizione: string; // nota sotto l'anteprima del modulo
}

export const PRECEDENZA: PrecedenzaItem[] = [
  {
    tier: 1,
    titolo: "un'agenzia, su un'offerta",
    descrizione: "È la prima riga che il portale guarda.",
  },
  {
    tier: 2,
    titolo: "un'agenzia, su un fornitore",
    descrizione: "Conta solo se la riga 1 non corrisponde alla pratica.",
  },
  {
    tier: 3,
    titolo: "un'agenzia, su tutto",
    descrizione: "Conta solo se le righe 1 e 2 non corrispondono alla pratica.",
  },
  {
    tier: 4,
    titolo: "un'offerta, per tutte le agenzie",
    descrizione: "Conta solo se le righe da 1 a 3 non corrispondono alla pratica.",
  },
  {
    tier: 5,
    titolo: "un fornitore, per tutte le agenzie",
    descrizione: "Conta solo se le righe da 1 a 4 non corrispondono alla pratica.",
  },
  {
    tier: 6,
    titolo: "tutte le altre pratiche",
    descrizione: "Conta solo se nessuna riga sopra corrisponde alla pratica.",
  },
];

export function tierForTargeting(
  agenziaId?: string | null,
  offertaId?: string | null,
  fornitore?: string | null,
): number | null {
  const A = !!agenziaId, O = !!offertaId, F = !!fornitore;
  if (A && O && !F) return 1;
  if (A && F && !O) return 2;
  if (A && !O && !F) return 3;
  if (!A && O && !F) return 4;
  if (!A && !O && F) return 5;
  if (!A && !O && !F) return 6;
  return null;
}

/** "Vale per", per la colonna Riga e l'anteprima del modulo. */
export function tierLabel(tier: number | null): string {
  if (tier === null) return "combinazione non valida";
  return PRECEDENZA.find((p) => p.tier === tier)?.titolo ?? `riga ${tier}`;
}

/** Nota sotto l'anteprima del modulo. */
export function tierScope(tier: number | null): string {
  if (tier === null) return "Combinazione non valida.";
  return PRECEDENZA.find((p) => p.tier === tier)?.descrizione ?? "";
}
